import classnames from 'classnames/bind';
import style from './body.module.scss';
import InterviewPracticeQuestionDndList from './questionDndList';
import React from 'react';
import { DragDropContext, Droppable, DropResult } from 'react-beautiful-dnd';
import { useInterview } from '@components/pass/interview/start/context/interviewContext';
import Button from '@components/common/button';

interface Props {
  onStartClick: () => void;
  onCancelClick: () => void;
}

const cx = classnames.bind(style);

const InterviewPracticeQuestionSelectLastModelBody = (props: Props) => {
  const { selectedQuestionList, policies, swapQuestionOrder } = useInterview();
  const isDisable = selectedQuestionList.length < policies.interviewPracticeMinQuestionSize;

  const handleDragEnd = (result: DropResult) => {
    if (result.destination) {
      const item = selectedQuestionList?.[result.source.index];
      if (item) swapQuestionOrder(item.sn, result.destination.index);
    }
  };

  return (
    <div className={cx('body')}>
      <div className={cx('scrollArea')}>
        <div className={cx('questionListWrap')}>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId={'question-list-droppable'}>
              {(provided, snapshot) => <InterviewPracticeQuestionDndList provided={provided} snapshot={snapshot} />}
            </Droppable>
          </DragDropContext>
        </div>
      </div>
      <div className={cx('btnArea')}>
        <Button className={cx('btn')} theme="secondary" onClick={props.onCancelClick}>
          취소
        </Button>
        <Button className={cx('btn', { disable: isDisable })} onClick={props.onStartClick} disabled={false}>
          연습 시작하기
        </Button>
      </div>
    </div>
  );
};

export default InterviewPracticeQuestionSelectLastModelBody;
